module.exports = __webpack_public_path__ + "static/media/eu-map-mapa-mask.02321610.svg";